import { RadioGroup, RadioGroupItem } from '@plato/ui-legacy/components/ui/radio-group';
import { useTranslation } from 'react-i18next';

const viewModes = ['day', 'week'] as const;

export type ViewMode = (typeof viewModes)[number];

type Props = {
    className?: string;
    selectedMode: ViewMode;
    onModeChange: (mode: ViewMode) => void;
};

export function EventsViewModeSelector({ className = '', selectedMode, onModeChange }: Props) {
    const { t } = useTranslation();

    const handleValueChange = (value: string) => {
        onModeChange(value as ViewMode);
    };

    return (
        <RadioGroup value={selectedMode} onValueChange={handleValueChange} className={className}>
            {viewModes.map((period) => (
                <RadioGroupItem value={period} id={`period-${period}`} key={period}>
                    {period === 'day'
                        ? t('period__day', { ns: 'events' })
                        : t('period__week', { ns: 'events' })}
                </RadioGroupItem>
            ))}
        </RadioGroup>
    );
}
